// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codman-comparison-picker {
  white-space: nowrap;
}
.codman-comparison-picker .codman-comparison-picker__title {
  display: inline-block;
  vertical-align: middle;
}
.codman-comparison-picker .codman-comparison-picker__provider {
  display: inline-block;
  vertical-align: middle;
  margin-left: var(--spacing1);
}`, "",{"version":3,"sources":["webpack://./libs/shared/feature-comparison-picker/src/lib/comparison-picker/comparison-picker.component.scss"],"names":[],"mappings":"AAEA;EACI,mBAAA;AADJ;AAGI;EACI,qBAAA;EACA,sBAAA;AADR;AAII;EACI,qBAAA;EACA,sBAAA;EACA,4BAAA;AAFR","sourcesContent":["@use \"definitions\" as *;\n\n.codman-comparison-picker {\n    white-space: nowrap;\n\n    .codman-comparison-picker__title {\n        display: inline-block;\n        vertical-align: middle;\n    }\n\n    .codman-comparison-picker__provider {\n        display: inline-block;\n        vertical-align: middle;\n        margin-left: var(--spacing1);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
